import { render, staticRenderFns } from "./systemOverview2.vue?vue&type=template&id=4d22b834&scoped=true&"
import script from "./systemOverview2.vue?vue&type=script&lang=js&"
export * from "./systemOverview2.vue?vue&type=script&lang=js&"
import style0 from "./systemOverview2.vue?vue&type=style&index=0&id=4d22b834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22b834",
  null
  
)

export default component.exports